/*# sourceMappingURL=issue-overview-item.component-7BPZRTE5.css.map */
